module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/deals/deals-page/deals-page.component.css
// module id = ./src/app/components/deals/deals-page/deals-page.component.css
// module chunks = main